const actions = {
  LIST_TIPO_ORIGEN_PACIENTE: 'LIST_TIPO_ORIGEN_PACIENTE',
  LIST_TIPO_ORIGEN_PACIENTE_SELECTBOX: 'LIST_TIPO_ORIGEN_PACIENTE_SELECTBOX',
  CREATE_TIPO_ORIGEN_PACIENTE: 'CREATE_TIPO_ORIGEN_PACIENTE',
  READ_TIPO_ORIGEN_PACIENTE: 'READ_TIPO_ORIGEN_PACIENTE',
  UPDATE_TIPO_ORIGEN_PACIENTE: 'UPDATE_TIPO_ORIGEN_PACIENTE',
  DELETE_TIPO_ORIGEN_PACIENTE: 'DELETE_TIPO_ORIGEN_PACIENTE',

  tipoOrigenPacienteList: data => {     
    return {
      type: actions.LIST_TIPO_ORIGEN_PACIENTE,
      data,
    };
  },

  tipoOrigenPacienteListSelectBox: data => {
    return {
      type: actions.LIST_TIPO_ORIGEN_PACIENTE_SELECTBOX,
      data,
    };
  },

  tipoOrigenPacienteCreate: data => {
    return {
      type: actions.CREATE_TIPO_ORIGEN_PACIENTE,
      data,
    };
  },

  tipoOrigenPacienteRead: data => {
    return {
      type: actions.READ_TIPO_ORIGEN_PACIENTE,
      data,
    };
  },

  tipoOrigenPacienteUpdate: data => {
    return {
      type: actions.UPDATE_TIPO_ORIGEN_PACIENTE,
      data,
    };
  },

  tipoOrigenPacienteDelete: () => {
    return {
      type: actions.DELETE_TIPO_ORIGEN_PACIENTE,      
    };
  },
};

export default actions;
